/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputChatFile } from './OutputChatFile';
import {
    OutputChatFileFromJSON,
    OutputChatFileFromJSONTyped,
    OutputChatFileToJSON,
} from './OutputChatFile';
import type { OutputChatMessageUser } from './OutputChatMessageUser';
import {
    OutputChatMessageUserFromJSON,
    OutputChatMessageUserFromJSONTyped,
    OutputChatMessageUserToJSON,
} from './OutputChatMessageUser';
import type { OutputChatReaction } from './OutputChatReaction';
import {
    OutputChatReactionFromJSON,
    OutputChatReactionFromJSONTyped,
    OutputChatReactionToJSON,
} from './OutputChatReaction';

/**
 * 
 * @export
 * @interface OutputChatMessage
 */
export interface OutputChatMessage {
    /**
     * 
     * @type {string}
     * @memberof OutputChatMessage
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputChatMessage
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof OutputChatMessage
     */
    createdAt: string;
    /**
     * Заповнюється лише для сповіщення про вилучення
     * @type {string}
     * @memberof OutputChatMessage
     */
    deletedAt: string;
    /**
     * 
     * @type {Array<OutputChatFile>}
     * @memberof OutputChatMessage
     */
    files: Array<OutputChatFile>;
    /**
     * 
     * @type {number}
     * @memberof OutputChatMessage
     */
    id: number;
    /**
     * 
     * @type {Array<OutputChatReaction>}
     * @memberof OutputChatMessage
     */
    reactions: Array<OutputChatReaction>;
    /**
     * 
     * @type {OutputChatMessageUser}
     * @memberof OutputChatMessage
     */
    user: OutputChatMessageUser;
}

/**
 * Check if a given object implements the OutputChatMessage interface.
 */
export function instanceOfOutputChatMessage(value: object): boolean {
    if (!('updatedAt' in value)) return false;
    if (!('content' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('deletedAt' in value)) return false;
    if (!('files' in value)) return false;
    if (!('id' in value)) return false;
    if (!('reactions' in value)) return false;
    if (!('user' in value)) return false;
    return true;
}

export function OutputChatMessageFromJSON(json: any): OutputChatMessage {
    return OutputChatMessageFromJSONTyped(json, false);
}

export function OutputChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': json['UpdatedAt'],
        'content': json['content'],
        'createdAt': json['createdAt'],
        'deletedAt': json['deletedAt'],
        'files': ((json['files'] as Array<any>).map(OutputChatFileFromJSON)),
        'id': json['id'],
        'reactions': ((json['reactions'] as Array<any>).map(OutputChatReactionFromJSON)),
        'user': OutputChatMessageUserFromJSON(json['user']),
    };
}

export function OutputChatMessageToJSON(value?: OutputChatMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'UpdatedAt': value['updatedAt'],
        'content': value['content'],
        'createdAt': value['createdAt'],
        'deletedAt': value['deletedAt'],
        'files': ((value['files'] as Array<any>).map(OutputChatFileToJSON)),
        'id': value['id'],
        'reactions': ((value['reactions'] as Array<any>).map(OutputChatReactionToJSON)),
        'user': OutputChatMessageUserToJSON(value['user']),
    };
}

